module.exports = __webpack_public_path__ + "static/media/kyoto.8c3fa040.jpeg";